import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import withTranslateProvider from 'src/hoc/with-translate-provider'
import HeadMetaTags from '~/components/HeadMetaTags'
import TalentAIContainer from '~/features/talent-ai'

const TalentAIPage: FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <HeadMetaTags
        title={t('meta:talent_ai:meta_title')}
        description={t('meta:talent_ai:meta_description')}
      />
      <TalentAIContainer />
    </>
  )
}

export default withTranslateProvider(TalentAIPage)
